document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-mdx-root]').forEach(function (root) {
    var main = root.querySelector('[data-mdx-gallery-main]');
    var dots = root.querySelectorAll('[data-mdx-dot]');
    var thumbs = root.querySelectorAll('[data-mdx-thumb]');
    var slides = main ? main.querySelectorAll('img') : [];

    function setActive(idx) {
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
    }

    if (main) {
      main.addEventListener('scroll', function () {
        var idx = Math.round(main.scrollLeft / main.clientWidth);
        setActive(idx);
      });
    }
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        if (main && slides[i]) main.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      });
    });
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        if (main && slides[i]) main.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      });
    });

    root.querySelectorAll('[data-mdx-acc-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.closest('[data-mdx-acc-item]').classList.toggle('is-open');
      });
    });
  });
});
